import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      home: 'Home',
      about: 'About',
      projects: 'Projects',
      gallery: 'Gallery',
      calculator: 'Calculator',
      blog: 'Blog',
      contact: 'Contact',
      partners: 'Partners',
      admin: 'Admin',
      
      // Home page
      heroTitle: 'Gjenerali SHPK Construction',
      welcomeTitle: 'Gjenerali SHPK Construction',
      welcomeSubtitle: 'Building Excellence Since 2008',
      welcomeDescription: 'Professional construction company delivering high-quality residential and commercial projects with attention to detail and customer satisfaction.',
      getQuote: 'Get Free Quote',
      viewProjects: 'View Projects',
      ourWork: 'Our Work',
      whyChooseUs: 'Why Choose Us',
      experienceYears: '15+ Years Experience',
      experienceDesc: 'Proven track record in construction',
      qualityWork: 'Quality Workmanship',
      qualityDesc: 'Attention to detail in every project',
      onTime: 'On-Time Delivery',
      onTimeDesc: 'Projects completed on schedule',
      yearsExperience: 'Years Experience',
      projectsCompleted: 'Projects Completed',
      happyClients: 'Happy Clients',
      residentialDesc: 'Custom homes and renovations',
      commercialDesc: 'Office buildings and retail spaces',
      renovationDesc: 'Modernizing existing structures',
      projectManagementDesc: 'End-to-end project coordination',
      
      // About page
      aboutTitle: 'About Our Company',
      aboutDescription: 'Premium construction services delivering excellence in residential and commercial projects. With over 15 years of experience, we build your vision with quality craftsmanship and attention to detail.',
      ourMission: 'Our Mission',
      ourVision: 'Our Vision',
      ourServices: 'Our Services',
      residentialConstruction: 'Residential Construction',
      commercialBuilding: 'Commercial Building',
      renovationsRemodeling: 'Renovations & Remodeling',
      projectManagement: 'Project Management',
      
      // Projects page
      ourProjects: 'Our Projects',
      noProjectsYet: 'No Projects Yet',
      noProjectsDesc: 'Our projects will appear here once added by the admin.',
      contactUsForProject: 'Contact Us for Your Project',
      recentUpdates: 'Recent Project Updates',
      
      // Gallery
      projectGallery: 'Project Gallery',
      galleryPreviewDesc: 'Take a look at some of our recent construction projects. From residential homes to commercial buildings, we deliver quality craftsmanship.',
      viewAllProjects: 'View Projects',
      allProjects: 'All Projects',
      beforeAfter: 'Before & After',
      residential: 'Residential',
      commercial: 'Commercial',
      noImagesYet: 'No Images Yet',
      noImagesDesc: 'Images will appear here when you add projects or upload files.',
      
      // Calculator
      constructionCalculator: 'Construction Cost Calculator',
      calculatorInstantEstimate: 'Get an instant estimate for your construction project',
      selectServiceType: 'Select Service Type',
      chooseService: 'Choose a service...',
      selectProjectType: 'Select Project Type',
      chooseProjectType: 'Choose your project type...',
      residentialBuilding: '🏠 Residential Building',
      commercialBuilding: '🏢 Commercial Building',
      renovationProject: '🔨 Renovation Project',
      areaSquareMeters: 'Area (Square Meters)',
      enterTotalArea: 'Enter total area in sqm...',
      enterArea: 'Enter area in m²...',
      numberOfFloors: 'Number of Floors',
      selectFloors: 'Select number of floors...',
      singleFloor: '1️⃣ Single Floor',
      twoFloors: '2️⃣ Two Floors',
      threeFloors: '3️⃣ Three or More Floors',
      materialQuality: 'Material Quality',
      chooseMaterialQuality: 'Choose material quality...',
      basicMaterials: '💰 Basic Materials',
      standardMaterials: '⭐ Standard Materials',
      premiumMaterials: '💎 Premium Materials',
      calculateEstimate: '🧮 Calculate Estimate',
      estimatedCost: 'Estimated Cost',
      service: 'Service',
      area: 'Area',
      pricePerM2: 'Price per m²',
      calculatorDisclaimer: '*This is an estimate. Final price may vary. Contact us for a detailed',
      quote: 'quote',
      noServicesAvailable: 'No services available at the moment. Please check back later.',
      roughEstimate: '*This is a rough estimate. Contact us for a detailed personalized quote.',
      
      // Contact
      readyToStart: 'Get Started',
      getFreeQuote: 'Get Your Free Quote Today',
      professionalServices: 'Professional construction services in Durres and surrounding areas',
      callUs: 'Call Us',
      callNow: 'Call Now',
      emailUs: 'Email Us',
      sendEmail: 'Send Email',
      whatsapp: 'WhatsApp',
      quickResponse: 'Quick Response',
      chatNow: 'Chat Now',
      findUs: 'Find Us',
      requestQuote: 'Request a Quote',
      contactUs: 'Contact Us',
      getInTouch: 'Get in Touch',
      contactDesc: 'Ready to start your construction project? Contact us today for a free consultation.',
      yourName: 'Your Name',
      yourEmail: 'Your Email',
      yourPhone: 'Your Phone',
      yourMessage: 'Your Message',
      sendMessage: 'Send Message',
      sendUsMessage: 'Send us a Message',
      selectProjectType: 'Select Project Type',
      projectType: 'Project Type',
      selectBudgetRange: 'Select Budget Range',
      budgetRange: 'Budget Range',
      under10k: 'Under €10,000',
      budget10k25k: '€10,000 - €25,000',
      budget25k50k: '€25,000 - €50,000',
      over50k: 'Over €50,000',
      projectDescription: 'Project Description',
      ourLocation: 'Our Location',
      visitUs: 'Visit Us',
      
      // Blog
      constructionNews: 'Construction News & Tips',
      modernTrends: 'Modern Construction Trends in Albania',
      modernTrendsDesc: 'Discover the latest trends in Albanian construction industry, from sustainable materials to smart home integration...',
      dreamHomeTips: 'Tips for Planning Your Dream Home',
      dreamHomeTipsDesc: 'Essential considerations when planning your new home construction project in Durres and surrounding areas...',
      buildingRegulations: 'Commercial Building Regulations in Albania',
      buildingRegulationsDesc: 'Understanding the legal requirements and permits needed for commercial construction projects...',
      readMore: 'Read More',
      
      // Testimonials
      testimonials: 'What Our Clients Say',
      
      // Common
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      close: 'Close',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      add: 'Add',
      update: 'Update',
      
      // Chat
      chatWelcome: 'Hi there! 👋 I\'m here to help with your construction project. Whether you need a quote, want to see our work, or have questions about our services - just ask! What can I assist you with today?',
      chatPlaceholder: 'Ask me about our construction services...',
      chatSend: 'Send',
      
      // Footer
      footerDescription: 'Professional construction company delivering high-quality residential and commercial projects with 15+ years of experience in Durres, Albania.',
      quickLinks: 'Quick Links',
      services: 'Services',
      contactInfo: 'Contact Info',
      workingHours: 'Working Hours',
      mondayFriday: 'Monday - Friday',
      saturday: 'Saturday',
      allRightsReserved: 'All rights reserved.',
      builtWith: 'Built with',
      inAlbania: 'in Albania',
      residentialConstruction: 'Residential Construction',
      commercialConstruction: 'Commercial Construction',
      projectManagement: 'Project Management',
      
      // Status
      planning: 'Planning',
      inProgress: 'In Progress',
      completed: 'Completed',
      onHold: 'On Hold',
      
      // Categories
      renovation: 'Renovation',
      infrastructure: 'Infrastructure'
    }
  },
  sq: {
    translation: {
      // Navigation
      home: 'Kryefaqja',
      about: 'Rreth Nesh',
      projects: 'Projektet',
      gallery: 'Galeria',
      calculator: 'Kalkulatori',
      blog: 'Blog',
      contact: 'Kontakti',
      partners: 'Partnerët',
      admin: 'Admin',
      
      // Home page
      heroTitle: 'Gjenerali SHPK Construction',
      welcomeTitle: 'Gjenerali SHPK Construction',
      welcomeSubtitle: 'Ndërtojmë Përsosmëri Që Nga 2008',
      welcomeDescription: 'Kompani profesionale ndërtimi që ofron projekte cilësore rezidenciale dhe komerciale me vëmendje ndaj detajeve dhe kënaqësi të klientit.',
      getQuote: 'Merrni Ofertë Falas',
      viewProjects: 'Shikoni Projektet',
      ourWork: 'Puna Jonë',
      whyChooseUs: 'Pse Na Zgjidhni Ne',
      experienceYears: '15+ Vjet Përvojë',
      experienceDesc: 'Rekord i provuar në ndërtim',
      qualityWork: 'Punë Cilësore',
      qualityDesc: 'Vëmendje ndaj detajeve në çdo projekt',
      onTime: 'Dorëzim në Kohë',
      onTimeDesc: 'Projekte të përfunduara në afat',
      yearsExperience: 'Vjet Përvojë',
      projectsCompleted: 'Projekte të Përfunduara',
      happyClients: 'Klientë të Kënaqur',
      residentialDesc: 'Shtëpi të personalizuara dhe rinovime',
      commercialDesc: 'Ndërtesa zyrtare dhe hapësira tregtare',
      renovationDesc: 'Modernizimi i strukturave ekzistuese',
      projectManagementDesc: 'Koordinim i plotë i projektit',
      
      // About page
      aboutTitle: 'Rreth Kompanisë Sonë',
      aboutDescription: 'Shërbime ndërtimi premium që ofrojnë përsosmëri në projekte rezidenciale dhe komerciale. Me mbi 15 vjet përvojë, ne ndërtojmë vizionin tuaj me cilësi zanafille dhe vëmendje ndaj detajeve.',
      ourMission: 'Misioni Ynë',
      ourVision: 'Vizioni Ynë',
      ourServices: 'Shërbimet Tona',
      residentialConstruction: 'Ndërtim Rezidencial',
      commercialBuilding: 'Ndërtim Komercial',
      renovationsRemodeling: 'Rinovime & Rimodelime',
      projectManagement: 'Menaxhim Projektesh',
      
      // Projects page
      ourProjects: 'Projektet Tona',
      noProjectsYet: 'Ende Pa Projekte',
      noProjectsDesc: 'Projektet tona do të shfaqen këtu pasi të shtohen nga administratori.',
      contactUsForProject: 'Na Kontaktoni për Projektin Tuaj',
      recentUpdates: 'Përditësime të Fundit të Projekteve',
      
      // Gallery
      projectGallery: 'Galeria e Projekteve',
      galleryPreviewDesc: 'Shikoni disa nga projektet tona të fundit të ndërtimit. Nga shtëpitë rezidenciale tek ndërtesat komerciale, ne ofrojmë punë cilësore.',
      viewAllProjects: 'Shikoni Të Gjitha Projektet',
      allProjects: 'Të Gjitha Projektet',
      beforeAfter: 'Para & Pas',
      residential: 'Rezidencial',
      commercial: 'Komercial',
      noImagesYet: 'Ende Pa Foto',
      noImagesDesc: 'Fotot do të shfaqen këtu kur të shtoni projekte ose të ngarkoni skedarë.',
      
      // Calculator
      constructionCalculator: 'Kalkulatori i Kostos së Ndërtimit',
      calculatorInstantEstimate: 'Merrni një vlerësim të menjëhershëm për projektin tuaj të ndërtimit',
      selectServiceType: 'Zgjidhni Llojin',
      chooseService: 'Zgjidhni një shërbim...',
      selectProjectType: 'Zgjidhni Llojin e Projektit',
      chooseProjectType: 'Zgjidhni llojin e projektit tuaj...',
      residentialBuilding: '🏠 Ndërtim Rezidencial',
      commercialBuilding: '🏢 Ndërtim Komercial',
      renovationProject: '🔨 Projekt Rinovimi',
      areaSquareMeters: 'Sipërfaqja',
      enterTotalArea: 'Shkruani sipërfaqen totale në m²...',
      enterArea: 'Shkruani sipërfaqen në m²...',
      numberOfFloors: 'Numri i Kateve',
      selectFloors: 'Zgjidhni numrin e kateve...',
      singleFloor: '1️⃣ Një Kat',
      twoFloors: '2️⃣ Dy Kate',
      threeFloors: '3️⃣ Tre ose Më Shumë Kate',
      materialQuality: 'Cilësia e Materialeve',
      chooseMaterialQuality: 'Zgjidhni cilësinë e materialeve...',
      basicMaterials: '💰 Materiale Bazë',
      standardMaterials: '⭐ Materiale Standarde',
      premiumMaterials: '💎 Materiale Premium',
      calculateEstimate: '🧮 Llogarit Vlerësimin',
      estimatedCost: 'Kostoja e Vlerësuar',
      service: 'Shërbimi',
      area: 'Sipërfaqja',
      pricePerM2: 'Çmimi për m²',
      calculatorDisclaimer: '*Ky është një vlerësim. Çmimi përfundimtar mund të ndryshojë. Na kontaktoni për një',
      quote: 'ofertë',
      noServicesAvailable: 'Nuk ka shërbime të disponueshme në këtë moment. Ju lutemi kontrolloni më vonë.',
      roughEstimate: '*Ky është një vlerësim i përafërt. Na kontaktoni për një ofertë të detajuar të personalizuar.',
      
      // Contact
      readyToStart: 'Filloni Tani',
      getFreeQuote: 'Merrni Ofertën Tuaj Falas Sot',
      professionalServices: 'Shërbime profesionale ndërtimi në Shqiperi dhe shtetet përreth',
      callUs: 'Na Telefononi',
      callNow: 'Telefononi Tani',
      emailUs: 'Na Shkruani Email',
      sendEmail: 'Dërgo Email',
      whatsapp: 'WhatsApp',
      quickResponse: 'Përgjigje e Shpejtë',
      chatNow: 'Bisedoni Tani',
      findUs: 'Na Gjeni',
      requestQuote: 'Kërkoni Ofertë',
      contactUs: 'Na Kontaktoni',
      getInTouch: 'Lidhuni me Ne',
      contactDesc: 'Gati të filloni projektin tuaj të ndërtimit? Na kontaktoni sot për një konsultim falas.',
      yourName: 'Emri Juaj',
      yourEmail: 'Email-i Juaj',
      yourPhone: 'Telefoni Juaj',
      yourMessage: 'Mesazhi Juaj',
      sendMessage: 'Dërgo Mesazhin',
      sendUsMessage: 'Dërgoni një Mesazh',
      selectProjectType: 'Zgjidhni Llojin e Projektit',
      projectType: 'Lloji i Projektit',
      selectBudgetRange: 'Zgjidhni Gamën e Buxhetit',
      budgetRange: 'Gama e Buxhetit',
      under10k: 'Nën €10,000',
      budget10k25k: '€10,000 - €25,000',
      budget25k50k: '€25,000 - €50,000',
      over50k: 'Mbi €50,000',
      projectDescription: 'Përshkrimi i Projektit',
      ourLocation: 'Vendndodhja Jonë',
      visitUs: 'Na Vizitoni',
      
      // Blog
      constructionNews: 'Lajme & Këshilla Ndërtimi',
      modernTrends: 'Tendencat Moderne të Ndërtimit në Shqipëri',
      modernTrendsDesc: 'Zbuloni tendencat më të fundit në industrinë shqiptare të ndërtimit, nga materialet e qëndrueshme deri te integrimi i shtëpive inteligjente...',
      dreamHomeTips: 'Këshilla për Planifikimin e Shtëpisë Tuaj të Ëndrrave',
      dreamHomeTipsDesc: 'Konsiderata thelbësore kur planifikoni projektin tuaj të ri të ndërtimit të shtëpisë në Durrës dhe zonat përreth...',
      buildingRegulations: 'Rregulloret e Ndërtimit Komercial në Shqipëri',
      buildingRegulationsDesc: 'Kuptimi i kërkesave ligjore dhe lejeve të nevojshme për projektet e ndërtimit komercial...',
      readMore: 'Lexo Më Shumë',
      
      // Testimonials
      testimonials: 'Çfarë Thonë Klientët Tanë',
      
      // Common
      loading: 'Duke u ngarkuar...',
      error: 'Gabim',
      success: 'Sukses',
      close: 'Mbyll',
      save: 'Ruaj',
      cancel: 'Anulo',
      edit: 'Ndrysho',
      delete: 'Fshi',
      add: 'Shto',
      update: 'Përditëso',
      
      // Chat
      chatWelcome: 'Përshëndetje! 👋 Jam këtu për t\'ju ndihmuar me projektin tuaj të ndërtimit. Qoftë për një ofertë, për të parë punën tonë, apo pyetje për shërbimet tona - pyetni lirisht! Si mund t\'ju ndihmoj sot?',
      chatPlaceholder: 'Pyetni për shërbimet tona të ndërtimit...',
      chatSend: 'Dërgo',
      
      // Footer
      footerDescription: 'Kompani profesionale ndërtimi që ofron projekte cilësore rezidenciale dhe komerciale me 15+ vjet përvojë në Durrës, Shqipëri.',
      quickLinks: 'Lidhje të Shpejta',
      services: 'Shërbime',
      contactInfo: 'Informacion Kontakti',
      workingHours: 'Orët e Punës',
      mondayFriday: 'E Hënë - E Premte',
      saturday: 'E Shtunë',
      allRightsReserved: 'Të gjitha të drejtat e rezervuara.',
      builtWith: 'Ndërtuar me',
      inAlbania: 'në Shqipëri',
      residentialConstruction: 'Ndërtim Rezidencial',
      commercialConstruction: 'Ndërtim Komercial',
      projectManagement: 'Menaxhim Projektesh',
      
      // Status
      planning: 'Planifikim',
      inProgress: 'Në Proces',
      completed: 'E Përfunduar',
      onHold: 'Në Pritje',
      
      // Categories
      renovation: 'Rinovim',
      infrastructure: 'Infrastrukturë'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'sq',
    lng: 'sq',
    debug: false,
    
    interpolation: {
      escapeValue: false
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;
